import localforage from 'localforage'

localforage.config({
  driver: localforage.LOCALSTORAGE,
  // driver: localforage.INDEXEDDB,
  name        : 'kati',
  version     : 1.0,
  storeName   : 'kati',
  description : 'Persistent data for kati application'
});

localforage.clear()

export default {
  async has(key) {
    try {
      return await this.get(key) !== null
    }
    catch (err) {
      return false
    }
  },
  async get(key) {
    return await localforage.getItem(key)
  },
  async set(key, value) {
    return await localforage.setItem(key, value)
  }
}
